'use strict';
const _ = require('underscore');
const Backbone = require('backbone');

const ActionType = Backbone.Model.extend({
    defaults: {
        name: '',
        states: [],
        transitions: [],
        _states: null,
        _transitions: null
    },
    validation: {
        name: {
            required: true
        }
    },

    toJSON: function() {
        let j = ActionType.__super__.toJSON.call(this);
        j.states = _.map(this.getStates(), s => s.id);
        j.transitions = _.map(this.getTransitions(), s => s.id);
        _.each(_.keys(j), k => {
            if(k.startsWith('_')) {
                delete j[k];
            }
        });
        return j;
    },

    getName: function() {
        return this.get('name');
    },

    getState: function(stateId) {
        return _.find(this.getStates(), s => s.id == stateId);
    },

    getStates: function() {
        return this.get('_states');
    },

    getStateByType: function(typeName) {
        return _.find(this.getStates(), s => s.getType().name == typeName);
    },

    getTransitions: function() {
        return this.get('_transitions');
    },

    getTransitionsBySource: function(state) {
        return _.filter(this.getTransitions(), t => {
            return !t.isDeleted() && t.getSource() == state.id;
        });
    },

    getProceedableStates: function(state) {
        const transitions = this.getTransitionsBySource(state);
        let states = _.map(transitions, t => {
            return this.getState(t.getTarget());
        });
        if(!_.contains(['terminated', 'final'], state.getType().name)) {
            states.push(this.getStateByType('terminated'));
        }

        return states;
    }
});

module.exports = ActionType;



// WEBPACK FOOTER //
// ./process/domain/entity/action/type.js